import logo from './logo.png';

export const Assets = {
    logo
}